<!-- eslint-disable no-undef -->
<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      Administrar Recordatorios
      <template v-slot:actions>
        <v-btn class="mr-5" @click.native.stop="getNextapoitments()" icon small>
          <v-icon color="primary">mdi-reload</v-icon>
        </v-btn>
        <v-btn @click.prevent="$store.dispatch('deleteWindowByUuid', { uuid: win.uuid })" icon small>
          <v-icon color="error">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content :key="reloadPatientsV">
      <v-card>
        <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
          <v-tabs-slider color="red"></v-tabs-slider>

          <v-tab href="#tab-1">
            GESTIÓN DE NOTIFICACIONES
            <v-icon>mdi-bell-ring</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-1">
            <v-card flat class="py-1 px-1">
              <block v-if="loading"></block>
              <v-card-text class="white py-4">
                <v-row class="mx-2">
                  <v-col class="tabsNh" cols="12">
                    <v-col
                      cols="12"
                      style="display: flex; justify-content: flex-end"
                    >
                      <Button 
                        icon="mdi-filter-remove"
                        color="warning"
                        class="mr-2"
                        size="small"
                        @click="cleanFilters()"
                      />
                      <Button 
                        v-if="usePdfReminders"
                        icon="mdi-file-pdf-box"
                        class="mr-2"
                        size="small"
                        @click="generatePdfReminders()"
                        :disabled="!isFiltered ? !apointmentList?.length : !dataFiltered?.length"
                      />
                      <Button 
                        icon="mdi-email"
                        color="success"
                        class="mr-2"
                        size="small"
                        @click="sendReminder()"
                      />
                    </v-col>
                  </v-col>
                  
                  <!-- Filtros movidos de la modal al área principal -->
                  <v-col cols="12" class="pb-0 mt-6">
                    <v-row>
                      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                        <v-autocomplete
                          outlined
                          dense
                          :items="TM"
                          item-text="Name"
                          item-value="Id"
                          label="Plantilla de correo"
                          v-model="selectedTemplate"
                          attach
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="3" md="2" lg="2" xl="2" v-if="false">
                        <v-autocomplete
                          outlined
                          dense
                          attach
                          :items="speciesList"
                          v-model="speciesSelected"
                          label="Especie"
                          @change="getNextapoitments()"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="3" md="2" lg="2" xl="2" v-if="false">
                        <v-autocomplete
                          outlined
                          dense
                          v-if="
                            speciesSelected == 'Canino' ||
                            speciesSelected == 'Felino'
                          "
                          :items="breedList"
                          attach
                          v-model="breedSelected"
                          label="Raza"
                          @change="getNextapoitments()"
                        ></v-autocomplete>
                        <v-text-field
                          outlined
                          dense
                          v-else
                          v-model="breedSelected"
                          label="Raza"
                          @change="getNextapoitments()"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3" md="2" lg="2" xl="2">
                        <date-picker
                          :value="startDate"
                          @dateSelected="
                            (param) => {
                              startDate = param;
                              getNextapoitments();
                            }
                          "
                          label="Fecha de inicio"
                        ></date-picker>
                      </v-col>
                      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                        <date-picker
                          :value="endDate"
                          @dateSelected="
                            (param) => {
                              endDate = param;
                              getNextapoitments();
                            }
                          "
                          label="Fecha de fin"
                        ></date-picker>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12">
                    <GeneralFilter
                      ref="generalFilter"
                      :search="search"
                      :filterEndpoint="filterPromise"
                      @filtered="filterHandler"
                      @emptyFilter="clearFilter"
                    >
                      <div class="d-flex flex-column flex-sm-row justify-space-between mt-2">
                        <div class="d-flex flex-row flex-wrap align-center">
                          <v-checkbox
                            v-model="showOnlySelected"
                            label="Mostrar solo seleccionados"
                            class="mr-5"
                            dense
                          />
                          <v-checkbox
                            v-model="showOnlySendEmail"
                            label="Solo clientes con envío de correo permitido"
                            class="mr-5"
                            dense
                            @change="getNextapoitments"
                          />
                        </div>
                        <div 
                          v-if="usePdfReminders"
                          class="d-flex flex-column flex-sm-row"
                        >
                          <Button
                            size="small"
                            prepend-icon="mdi-mailbox"
                            @click="selectWithMail"
                            class="mr-2 mt-2"
                            :disabled="!tableRenderData || tableRenderData.length <= 0"
                          >
                            Seleccionar con correo
                          </Button>
                          <Button
                            v-if="withMailSelected"
                            size="small"
                            color="warning"
                            prepend-icon="mdi-mailbox-open-outline"
                            @click="deselectWithMail"
                            class="mt-2"
                          >
                            Deseleccionar con correo
                          </Button>
                        </div>
                      </div>
                      <DxDataGrid class="isScrolledByGeneralFilter"
                        :data-source="tableRenderData"
                        :selectedRowKeys="selectedRowKeys"
                        key-expr="ID_Convert"
                        :show-row-lines="showRowLines"
                        :show-borders="showBorders"
                        :row-alternation-enabled="rowAlternationEnabled"
                        @selection-changed="onSelectionChanged($event)"
                        @exporting="onExporting"
                        width="100%" 
                        :scrolling="{useNative:true}" 
                        :column-auto-width="true" 
                        :word-wrap-enabled=true 
                      >
                        <DxPaging :page-size="10" />
                        <DxScrolling row-rendering-mode="virtual" />
                        <DxExport :enabled="true" />
                        <DxSelection mode="multiple" />
                        <DxColumn
                          cell-template="sendEmailTemplate"
                          caption="Email"
                          width="80"
                        ></DxColumn>
                        <DxColumn
                          data-field="ID_Patient"
                          caption="ID de Paciente"
                        ></DxColumn>
                        <DxColumn
                          data-field="veterinary_patient.NamePatient"
                          caption="Nombre de Paciente"
                        ></DxColumn>
                        <DxColumn
                          data-field="veterinary_patient.customer.LegalName"
                          caption="Nombre cliente"
                        ></DxColumn>
                        <DxColumn
                          :calculate-cell-value="row => row.veterinary_patient?.customer
                                          ? (row.veterinary_patient.customer.Is_a_Business ? row.veterinary_patient.customer.BusinessPhone : row.veterinary_patient.customer.PhoneNumber)
                                          : ''"
                          caption="Telefono"
                        ></DxColumn>
                        <DxColumn
                          :calculate-cell-value="row => row.veterinary_patient?.customer
                                              ? (row.veterinary_patient.customer.Is_a_Business 
                                                  ? row.veterinary_patient.customer.BusinessMobileNumber 
                                                  : row.veterinary_patient.customer.MobileNumber) 
                                              : ''"
                          caption="Movil"
                        ></DxColumn>
                        <DxColumn
                          :calculate-cell-value="row => row.veterinary_patient?.customer
                                              ? (row.veterinary_patient.customer.Is_a_Business 
                                                  ? row.veterinary_patient.customer.BusinessEmail 
                                                  : row.veterinary_patient.customer.Email) 
                                              : ''"
                          caption="Correo electrónico"
                        ></DxColumn>
                        <DxColumn
                          v-if="usePdfReminders"
                          :calculate-cell-value="row => row.veterinary_patient?.SendMail
                                              ? 'Sí' 
                                              : 'No'"
                          caption="Correo físico"
                          width="100"
                        ></DxColumn>
                        <DxColumn
                          data-field="NotificationType"
                          caption="Tipo de notificacion"
                        ></DxColumn>
                        <DxColumn
                          data-field="Medicine"
                          caption="Detalles"
                        ></DxColumn>
                        <DxColumn
                          data-field="NotificationDate"
                          caption="Fecha de notificacion"
                        ></DxColumn>
                        <template #show-template="{ data }">
                          <a
                            href="#"
                            class="mx-1"
                            @click="patientSelected(data)"
                          >
                            <v-icon color="primary">mdi-eye</v-icon>
                          </a>
                        </template>
                        <template #sendEmailTemplate="{ data }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                :color="canSendEmail(data.data) ? 'success' : 'error'"
                              >
                                {{ canSendEmail(data.data) ? 'mdi-email-check-outline' : 'mdi-email-off-outline' }}
                              </v-icon>
                            </template>
                            <span>
                              {{ canSendEmail(data.data)
                                ? 'Este cliente permite envío de correos'
                                : 'Este cliente no permite envío de correos' }}
                            </span>
                          </v-tooltip>
                        </template>
                      </DxDataGrid>
                    </GeneralFilter>
                  </v-col>
                </v-row>
              </v-card-text>

            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <alerts
          v-if="alert.show"
          v-on:close_alert="closeAlert"
          v-on:accept_alert="acceptAlert"
          :properties="alert"
        ></alerts>
        <VeterinaryRemindersPdf ref="pdfReminders"/>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import GeneralFilter from "@/components/GeneralFilter";
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  DxPaging,
  DxSelection,
  DxExport,
} from "devextreme-vue/data-grid";
import { mapGetters, mapState } from "vuex";
import DatePicker from "../../components/DatePicker.vue";
import { DogSpecies, CatSpecies } from "../../helpers/species";
import Block from "@/components/Block";
import Alerts from "@/components/Alerts";
import { printToExcel } from "@/helpers/printToexcel";
import Button from "@/components/Button";
import VeterinaryRemindersPdf from "./reminders/RemindersPdf.vue";

export default {
  name: "VeterinaryPatientReminders",
  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxPaging,
    DatePicker,
    DxSelection,
    Block,
    Alerts,
    DxExport,
    GeneralFilter,
    Button,
    VeterinaryRemindersPdf,
  },
  props: ["win"],
  data() {
    return {
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      loading: false,
      speciesList: ["Canino", "Felino", "Roedor", "Reptil", "Ave", "Otro"],
      search: {},
      dialogDelete: false,
      tab: null,
      veterinarypatients: [],
      showPatient: false,
      showRowLines: true,
      showBorders: true,
      rowAlternationEnabled: true,
      reloadPatientsV: 0,
      showOnlyDogs: false,
      showOnlyCats: false,
      showOnlyOthers: false,
      currentWeek: 0,
      selctedPatients: [],
      startDate: null,
      dataMail: [],
      endDate: null,
      TM: [[]],
      selectedTemplate: null,
      speciesSelected: null,
      breedSelected: null,
      dataAppointment: {},
      isFiltered: false,
      dataFiltered: [],
      didHaveAllData: false,
      usePdfReminders: false,
      selectedRowKeys: [],
      showOnlySelected: false,
      showOnlySendEmail: false,
    };
  },
  computed: {
    ...mapGetters(["reloadData"]),
    ...mapState("rolesUser", {
      rolesStatus: (state) => state.roles,
    }),
    apointmentList() {
      let template = this.TM.find((item) => {
        return item.Id == this.selectedTemplate;
      });
      if (template)
        return this.veterinarypatients.filter((item) => {
          return item.typeN == template.Type;
        });
      else return this.veterinarypatients;
    },
    breedList() {
      if (this.speciesSelected == "Canino") return DogSpecies;
      else if (this.speciesSelected == "Felino") return CatSpecies;
      else return [];
    },
    tableBaseData() {
      return !this.isFiltered 
        ? this.apointmentList 
        : this.dataFiltered
    },
    tableRenderData() {
      return this.showOnlySelected 
        ? this.selectedRows
        : this.tableBaseData
    },
    selectedRows() {
      const data = this.tableBaseData

      return data.filter(row => {
        const rowSelectedFound = this.selectedRowKeys.find(selectedKey => {
          return selectedKey === row.ID_Convert;
        })

        return !!rowSelectedFound;
      })
    },
    withMailSelected() {
      const some = this.selectedRows.some(row => {
        const patient = row.veterinary_patient

        return patient.SendMail;
      })

      return some;
    },
  },
  watch: {
    reloadData: {
      immediate: true,
      handler: "reloadPatients",
    },
  },
  mounted() {
    const userData = JSON.parse(localStorage.getItem("user"))
    this.search.business = userData.businessid || "";
    this.search.branch = userData.branch || "";
    const keymaster = userData.keymaster || '';

    if (keymaster === '1fcb87f1db97ed50906e821391eaa895' || keymaster === '47770e9a83f6f46af2a3d2b93fff710a') {
      this.usePdfReminders = true;
    }

    this.getCurrentWeek();
    this.getTemplateList();
    this.getNextapoitments();
  },
  methods: {
    async generatePdfReminders() {
      this.loading = true;
      try {
        let data = [];

        if (this.selectedRows?.length) {
          data = this.selectedRows;
        } else {
          data = !this.isFiltered ? this.apointmentList : this.dataFiltered
        }

        await this.$refs.pdfReminders.generateReport(data);
      } catch (err) {
        console.log(err)
      }
      this.loading = false;
    },
    onExporting(e) {
      printToExcel(e, "Recordatorios");
    },
    cleanFilters() {
      this.speciesSelected = null;
      this.breedSelected = null;
      this.startDate = null;
      this.endDate = null;
      this.showOnlySendEmail = false;
      this.getCurrentWeek();
      this.getNextapoitments();
    },
    closeAlert() {
      this.alert.show = false;
    },
    acceptAlert() {
      this.alert.show = false;
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },
    getNextapoitments() {
      this.loading = true;
      this.isFiltered = false;
      this.dataFiltered = [];
      let data = {
        startDate: this.startDate,
        endDate: this.endDate,
        onlySendEmail: this.showOnlySendEmail,
      };

      this.dataAppointment = {
        startDate: this.startDate,
        endDate: this.endDate,
      };

      this.search.dataAppointment = this.dataAppointment;
      this.$API.veterinarypatients
        .findnextApoitmentsHistory(data || this.dataAppointment)
        .then((response) => {
          response.map((item) => {
            if (item.patient) {
              item.Breed = item.patient.Breed;
              item.NamePatient = item.patient.NamePatient;
              item.ID_Customer = item.patient.ID_Customer;
              item.ID_Patient = item.patient.ID_Patient;
              item.NotificationEmail = item.patient.NotificationEmail;
              item.SendMail = item.patient.SendMail; 
              item.SendEmail = item.patient.SendEmail;
            }
            switch (item.typeN) {
              case "Grooming":
                item.NotificationType = "Peluquería";
                item.NotificationDate = item.NextAppointment;
                item.ID_Convert = item.ID_VPG + "Grooming";
                break;
              case "Medications":
                item.NotificationType =
                  item.ItemType == "VAC" ? "Vacunas" : "Medicamentos";
                item.NotificationDate = item.NextTime;
                item.ID_Convert = item.ID_VPMP + "Medications";
                break;
              case "Surgery":
                item.NotificationType = "Cirugía";
                item.NotificationDate = item.SurgeryDate;
                item.ID_Convert = item.ID_Surgery + "Surgery";
                break;
              case "Prescription":
                item.NotificationType = "Prescripción";
                item.NotificationDate = item.NextAppointment;
                item.ID_Convert = item.ID_VPMP + "Prescription";
                break;
              default:
                item.NotificationType = "Otro";

                break;
            }
            return {
              ...item,
            };
          });

          response = this.filterData(response);

          this.veterinarypatients = response;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getNextapoitmentsAllList() {
      this.loading = true;
      let data = {
        startDate: this.startDate,
        endDate: this.endDate,
      };

      this.dataAppointment = {
        startDate: this.startDate,
        endDate: this.endDate,
      };

      this.search.dataAppointment = this.dataAppointment;
      this.$API.veterinarypatients
        .findnextApoitments(data || this.dataAppointment)
        .then((response) => {
          response.map((item) => {
            if (item.patient) {
              item.Breed = item.patient.Breed;
              item.NamePatient = item.patient.NamePatient;
              item.ID_Customer = item.patient.ID_Customer;
              item.ID_Patient = item.patient.ID_Patient;
              item.NotificationEmail = item.patient.NotificationEmail;
              item.SendEmail = item.patient.SendEmail;
            }
            switch (item.typeN) {
              case "Grooming":
                item.NotificationType = "Peluquería";
                item.NotificationDate = item.NextAppointment;
                item.ID_Convert = item.ID_VPG + "Grooming";
                break;
              case "Medications":
                item.NotificationType =
                  item.ItemType == "VAC" ? "Vacunas" : "Medicamentos";
                item.NotificationDate = item.NextTime;
                item.ID_Convert = item.ID_VPMP + "Medications";
                break;
              case "Surgery":
                item.NotificationType = "Cirugía";
                item.NotificationDate = item.SurgeryDate;
                item.ID_Convert = item.ID_Surgery + "Surgery";
                break;
              case "Prescription":
                item.NotificationType = "Prescripción";
                item.NotificationDate = item.NextAppointment;
                item.ID_Convert = item.ID_VPMP + "Prescription";
                break;
              default:
                item.NotificationType = "Otro";

                break;
            }
            return {
              ...item,
            };
          });

          response = this.filterData(response);

          this.veterinarypatients = response;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    filterData(data) {
      data = data.filter((item) => {
        if (this.speciesSelected) {
          if (item.patient.Species != this.speciesSelected) return false;
        }
        if (this.breedSelected) {
          if (item.patient.Breed != this.breedSelected) return false;
        }
        return true;
      });
      return data;
    },
    onSelectionChanged(event) {
      let selectedRowsData = event.selectedRowsData;
      this.selectedRowKeys = [...event.selectedRowKeys];
      var isDeselect = false;
      if (event.currentDeselectedRowKeys.length > 0) {
        isDeselect = true;
        Object.assign(
          {},
          ...event.currentDeselectedRowKeys.map((x) => {
            this.dataMail.splice(
              this.dataMail.findIndex(
                (item) => item.ID_Convert === x.ID_Convert
              ),
              1
            );
          })
        );
      } else {
        isDeselect = false;
      }
      if (isDeselect == false) {
        this.dataMail = [];
        var parsedobj = JSON.parse(JSON.stringify(selectedRowsData));
        Object.assign(
          {},
          ...parsedobj.map((x) => {
            this.dataMail.push(x);
          })
        );
      }
    },
    getCurrentWeek() {
      const currentDate = new Date();
      const firstDayOfYear = new Date(currentDate.getFullYear(), 0, 1);
      const pastDaysOfYear = (currentDate - firstDayOfYear) / 86400000;
      this.currentWeek = Math.ceil(
        (pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7
      );

      const startDate = new Date();
      startDate.setDate(startDate.getDate() + 1);
      const endDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate() + 6
      );

      this.startDate = this.moment(startDate).format("DD/MM/YYYY");
      this.endDate = this.moment(endDate).format("DD/MM/YYYY");
    },
    sendReminder() {
      this.loading = true;
      let template = this.TM.find((item) => {
        return item.Id == this.selectedTemplate;
      });
      let data = {
        mailBoxData: this.dataMail,
        templateData: template,
      };
      this.$API.notification
        .sendVeterinaryReminder(data) 
        .then(() => {
          this.loading = false;
          this.showAlert(
            "success",
            "Notificacion enviada",
            "Se ha enviado la notificacion correctamente"
          );
        })
        .catch(() => {
          this.loading = false;
          this.showAlert(
            "danger",
            "Error",
            "Ha ocurrido un error al enviar la notificacion"
          );
        });
    },
    getTemplateList() {
      this.$API.TM.getTM().then((response) => {
        response = response.filter((item) => {
          return (
            item.State == 1 &&
            (item.Type == "Grooming" ||
              item.Type == "Medications" ||
              item.Type == "Surgery" ||
              item.Type == "Prescription")
          );
        });
        //console.log('/// Listado', response)
        this.selectedTemplate = response[0].Id;
        this.TM = response;
      });
    },
    async reloadPatients() {
      if (this.reloadData == "veterinarypatients") {
        await this.getAllPatients();
        this.$store.dispatch("reloadData", null);
      }
      setTimeout(() => {
        window.scrollTo(0, this.$store.getters.getScrollTop);
        //alert(this.$store.getters.getScrollTop)
      }, 300);
    },
    patientSelected(data) {
      // this.$store.dispatch('deleteWindow', {name: 'patientData'});

      this.$API.customers
        .getOneCustomer(data.data.ID_Customer)
        .then((response) => {
          data.data.customer = response;

          this.$store.dispatch("addWindow", {
            name: "veterinaryPatientData",
            component: "VeterinaryPatientData",
            unique: false,
            meta: { veterinarypatients: data.data, reload: true },
          });
        });
    },
    filterPromise(filterObj) {
      const filterArray = [
        "veterinary_patient.ID_Patient",
        "veterinary_patient.NamePatient",
        "veterinary_patient.ID_Customer", 
        "veterinary_patient.Breed",
        "veterinary_patient.NotificationEmail",
        "veterinary_patient.customer.LegalName",
        "veterinary_patient.customer.PhoneNumber",
        "veterinary_patient.customer.BusinessPhone",
        "veterinary_patient.customer.MobileNumber",
        "veterinary_patient.customer.BusinessMobileNumber",
        "veterinary_patient.customer.Email",
        "veterinary_patient.customer.BusinessEmail",
        "NotificationType",
        "NotificationDate",
      ];
      
      return new Promise((resolve, reject) => {
        try {
          // Función personalizada para filtrar con objetos anidados
          const customFilter = (data, searchTerm) => {
            if (!searchTerm) return data;
            
            return data.filter(item => {
              // Función para obtener valor de ruta anidada
              const getNestedValue = (obj, path) => {
                return path.split('.').reduce((current, key) => {
                  return current && current[key] !== undefined ? current[key] : null;
                }, obj);
              };
              
              // Buscar en todos los campos definidos
              return filterArray.some(field => {
                const value = getNestedValue(item, field);
                return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase());
              });
            });
          };
          
          const result = customFilter(this.apointmentList, filterObj.filter);
          resolve(result);
        } catch (error) {
          reject(error);
        }
      });
    },
    canSendEmail(row) {
      return Number(row?.veterinary_patient?.SendEmail) === 1;
    },
    clearFilter() {
      this.isFiltered = false;
    },
    filterHandler(response) {
      // Ahora siempre usa búsqueda directa al backend
      // if (response.length === 0 && this.didHaveAllData === false) {
      //   this.didHaveAllData = true;
      //   this.getNextapoitmentsAllList();
      //   this.$refs.generalFilter.filterHandler();
      // }
      const currentSelection = [...this.selectedRows];
      
      this.isFiltered = true;
      
      this.dataFiltered = response;
      
      if (currentSelection?.length) {
        currentSelection.forEach(row => {
          if (!this.dataFiltered.find(item => item.ID_Convert === row.ID_Convert)) {
            this.dataFiltered.push(row)
          }
        })

        this.dataFiltered = [...this.dataFiltered]
      }
      
    },
    selectWithMail() {
      for (const appointment of this.veterinarypatients) {
        const patient = appointment.veterinary_patient
        if (patient.SendMail && !this.selectedRowKeys.find(key => key === appointment.ID_Convert)) {
          this.selectedRowKeys.push(appointment.ID_Convert);
        }
      }
      
      this.selectedRowKeys = [...this.selectedRowKeys];
    },
    deselectWithMail() {
      const toDeselect = [];

      for (const appointment of this.veterinarypatients) {
        const patient = appointment.veterinary_patient
        if (patient.SendMail && this.selectedRowKeys.find(key => key === appointment.ID_Convert)) {
          toDeselect.push(appointment.ID_Convert);
        }
      }

      this.selectedRowKeys = this.selectedRowKeys.filter(key => !toDeselect.includes(key));
    }
  },
};
</script>

<style scoped>
.v-input__control {
  background: white !important;
}
.tabsNh {
  width: 100%;
  padding: 10px;

  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}
.btndelete {
  background-color: #e3191e !important;
  color: white;
}

.btn-add {
  background-color: #3498db !important;
  color: white;
}

.btnclean {
  background-color: #f29d35 !important;
  color: white;
}
</style>
